module.exports = __webpack_public_path__ + "img/sponsorC11.ff91853a.png";